// src/pages/About.js
import React from 'react';
import { Helmet } from 'react-helmet';
import Card from '../components/Card';
import frameImage1 from '../assets/stab2-min.jpg';
import frameImage2 from '../assets/refit-min.jpg';
import frameImage3 from '../assets/mechanic-min.jpg';
import frameImage4 from '../assets/yacht_services-min.jpg';
import aboutBackground from '../assets/sea3-min.jpg'; // Background image for the About page

function About() {
  const pageStyle = {
    backgroundImage: `url(${aboutBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no•repeat',
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

  return (
    <div style={pageStyle}>
      <Helmet>
        <title>About | PROPS Yacht Consulting</title>
        <meta name="description" content="About us page of PROPS Yacht Consulting" />
      </Helmet>
      <Card
        title="NEW BUILD"
        content={[
          "• Project Conception",
          "• Specifications",
          "• Change Orders",
          "• Proactive Inspections",
          "• Reports and Meetings",
          "• Crew Assistance for Setup and Delivery",
        ]}
        height='350px'
        frameImage={frameImage1}
        //Desktop styles
        textPosition= {{top: "60px", left: "100px"}}
        imageStyle={{
          top: '20px',
          right: '100px',
          width: '300px',
          height: '250px',
        }}
        //Mobile styles
        mobileHeight='260px'
        mobileTextPosition= {{top: "80px", left: "10px"}}
        mobileImageStyle={{
          top: '10px',
          right: '10px',
          width: '180px',
          height: '130px',
        }}
      />
      <Card 
        title="REFIT"
        content={[
          "• Quotations",
          "• Choice of Shipyard",
          <>
            • Assistance for Design <br />&nbsp;&nbsp;&nbsp;and Technicalities
          </>,
          "• Proactive Inspections",
          "• Reports and Meetings",
          "• Crew Assistance",
        ]}
        frameImage={frameImage2}
        //Desktop styles
        textPosition={{ top: "70px", right: "150px"}}
        imageStyle={{
          top: '25px',
          left: '50px',
          width: '450px',
          height: '300px',
        }}
        //Mobile styles
        mobileHeight='250px'
        mobileTextPosition={{ top: "30px", left: "200px"}}
        mobileImageStyle={{
          top: '30px',
          left: '10px',
          width: '160px',
          height: '100px',
        }}
      />
      <Card
        title="ASSISTANCE FOR INSPECTIONS"
        content={[
          "• Warranty Project Management",
          "• Major Class Inspections",
          "• Major Flag Inspections",
          "• Budget Supervision and Optimisation",
        ]}
        frameImage={frameImage3}
        //Desktop styles
        textPosition={{ top: "120px", right: "100px" }}
        imageStyle={{
          top: '30px',
          left: '50px',
          width: '450px',
          height: '300px',
        }}
        //Mobile styles
        mobileHeight='300px'
        mobileTextPosition={{ top: "10px", left: "140px"}}
        mobileImageStyle={{
          top: '100px',
          left: '10px',
          width: '180px',
          height: '120px',
        }}
      />
      <Card
        title="YACHT SERVICES"
        content={[
          "• General Yacht Delivery",
          "• Cargoship Load and Unload",
          "• Crew Introduction",
          <>
            • New Yacht Setup <br />&nbsp;&nbsp;&nbsp;and Delivery
          </>,
          "• Crew Training",
        ]}
        frameImage={frameImage4}
        //Desktop styles
        textPosition={{ top: "95px", left: "140px" }}
        imageStyle={{
          top: '30px',
          right: '50px',
          width: '450px',
          height: '300px',
        }}
        //Mobile styles
        mobileHeight='250px'
        mobileTextPosition={{ top: "10px", left: "10px" }}
        mobileImageStyle={{
          top: '60px',
          right: '10px',
          width: '160px',
          height: '100px',
        }}
      />
    </div>
  );
}

export default About;
